export const SectionTypes = {
    DEFAULT_CATEGORY: 'default_category',
    DEFAULT_TAG: 'default_tag',
    CATEGORY: 'category',
    CUSTOM: 'custom',
    TAG: 'tag',
    USER_CATEGORY_SELECTION: 'user_category_selection',
    NO_LOGIC: 'no_logic',
    TA_PLACEMENT_ENGINE: 'ta-placement-engine',
    EXTERNAL_WIDGET: 'external_widget',
    CONTENT_BLOCK: 'content_block',
} as const;

export type SectionType = (typeof SectionTypes)[keyof typeof SectionTypes];

export const SectionLayouts = {
    DEFAULT: 'default',
    LESERBILDER: 'leserbilder',
    SERIES: 'series',
    LEMATIN: 'lematin',
    TOP_UNBALANCED: 'topUnbalanced',
    TOP_BALANCED: 'topBalanced',
    STANDARD_UNBALANCED: 'standardUnbalanced',
    STANDARD_BALANCED: 'standardBalanced',
    SPECIAL: 'special',
    INCENTIVES: 'incentives',
    LIFESTYLE: 'lifestyle',
    EDITORIAL_PICK: 'editorialPick',
    VENTY: 'venty',
    FRIDAY: 'friday',
    CAROUSEL: 'carousel',
    SUBNAVIGATION: 'subnavigation',
    ZUERITIPP: 'zueriTipp',
    DASMAGAZIN: 'dasMagazin',
    VIDEO: 'video',
    SIGNE_GENEVE: 'signeGeneve',
    FOCUS: 'focus',
    BREAKING: 'breaking',
    HIGHLIGHT: 'highlight',
    NEWFRONT_BUNDLE: 'newfront_bundle',
    NEWFRONT_HIGHLIGHT: 'newfront_highlight',
    NEWFRONT_HORIZONTALSCROLL: 'newfront_horizontal-scroll',
    NEWFRONT_LIST: 'newfront_list',
    NEWFRONT_MICRO: 'newfront_micro',
    NEWFRONT_OPENER_LIST: 'newfront_opener-list',
    NEWFRONT_OPENER_TOP: 'newfront_opener-top',
    NEWFRONT_STANDARD_EVEN: 'newfront_standard-even',
    NEWFRONT_STANDARD_UNEVEN: 'newfront_standard-uneven',
    NEWFRONT_PANORAMA: 'newfront_panorama',
    NEWFRONT_HORIZONTAL_STACKED: 'newfront_horizontal-stacked',
    NEWFRONT_OPENER_OVERVIEW: 'newfront_opener-overview',
    NEWFRONT_LATEST_NEWS: 'newfront_latest-news',
    NEWFRONT_NEWSBRIEFING: 'newfront_newsbriefing',
} as const;

export const SectionButtonTypes = {
    CATEGORY: 'categoryLink',
    TAG: 'tagLink',
    EXTERNAL: 'link',
    INTERNAL: 'internalLink',
    TEXT_ITEM: 'text-item',
} as const;

export const NavigationLayoutTypes = {
    DROPDOWN: 'dropdown',
    LINK: 'link',
} as const;

export const SectionBackgroundColorTypes = {
    NONE: 'none',
    NEUTRAL: 'neutral',
    TENANT_COLOR: 'tenantColor',
    BLUE: 'blue',
    BROWN: 'brown',
    GREEN: 'green',
    MINT: 'mint',
    ORANGE: 'orange',
    PINK: 'pink',
    PURPLE: 'purple',
} as const;
